<template>
  <div :class="['card-search-term', { 'card-search-term--current': isCurrent }]" @click.prevent="onSearchTermClick">
    <div class="card-search-term__top">
      <div class="card-search-term__text">
        <strong>{{ searchTerm.text }}</strong>
        <small v-if="searchTerm.lastGeogrid" class="mb-0 d-block">{{ formatDate }}</small>
      </div>

      <div class="card-search-term__geogrid" v-if="searchTerm.lastGeogrid">
        <GeogridPreview :ranks="searchTerm.lastGeogrid.gridRanks" />
      </div>
    </div>

    <SearchTermBottomCharts :st="searchTerm" :chart-metric="chartMetric" @selectChartMetric="selectChartMetric" />
  </div>
</template>

<script>
import GeogridPreview from 'vue_widgets/geogrids/components/geogrid_preview'
import SearchTermBottomCharts from 'vue_widgets/geogrids/scheduled/show/search_term_bottom_charts'
import formatISODatetime from '../../../../helpers/formatters'

export default {
  components: { GeogridPreview, SearchTermBottomCharts },
  props: {
    searchTerm: { type: Object, required: true },
    isCurrent: { type: Boolean, required: true }
  },
  data() {
    return {
      chartMetric: 'agr'
    }
  },
  created() {
    this.formatDate = formatISODatetime(this.searchTerm.lastGeogrid.createdAt, 'fullWithTZ')
  },
  computed: {
    hasHistoricalData() {
      return this.searchTerm.metricHistory?.agrsHistory && this.searchTerm.metricHistory.agrsHistory.length > 1
    }
  },
  methods: {
    onSearchTermClick() {
      if (this.isCurrent) return
      this.$emit('changeCurrentSearchTerm', this.searchTerm)
    },
    selectChartMetric(metricName) {
      if (!this.isCurrent) return

      this.chartMetric = metricName
    }
  }
}
</script>
